/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrElectrocardiogramTypename = "PhrElectrocardiogram" as const;

/**
 *
 * @export
 * @interface PhrElectrocardiogram
 */
export interface PhrElectrocardiogram {
  /**
   *
   * @type {string}
   * @memberof PhrElectrocardiogram
   */
  hasImpression?: string;
  /**
   *
   * @type {string}
   * @memberof PhrElectrocardiogram
   */
  impression?: string;
  /**
   *
   * @type {string}
   * @memberof PhrElectrocardiogram
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof PhrElectrocardiogram
   */
  target?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrElectrocardiogram
   */
  readonly __typename?: string;
}

export function PhrElectrocardiogramFromJSON(json: any): PhrElectrocardiogram {
  return PhrElectrocardiogramFromJSONTyped(json, false);
}

export function PhrElectrocardiogramFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrElectrocardiogram {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrElectrocardiogramTypename,

    hasImpression: !exists(json, "has_impression") ? undefined : json["has_impression"],
    impression: !exists(json, "impression") ? undefined : json["impression"],
    reason: !exists(json, "reason") ? undefined : json["reason"],
    target: !exists(json, "target") ? undefined : json["target"],
  };
}

export function PhrElectrocardiogramToJSON(object?: PhrElectrocardiogram | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    has_impression: value.hasImpression,
    impression: value.impression,
    reason: value.reason,
    target: value.target,
  };
}
